export const WOKA_RENDER_SCALE = 1.4;
export const WOKA_FRAME_SIZE = 32;
export const WOKA_RENDER_OFFSET_Y = -((WOKA_RENDER_SCALE - 1) * WOKA_FRAME_SIZE) / 2;
export const WOKA_UI_OFFSET_Y = -(WOKA_RENDER_SCALE - 1) * WOKA_FRAME_SIZE;

export type WokaRenderTarget = {
    setScale(scale: number): unknown;
    setPosition(x: number, y: number): unknown;
};

export function applyWokaRenderTransform(sprite: WokaRenderTarget): void {
    sprite.setScale(WOKA_RENDER_SCALE);
    sprite.setPosition(0, WOKA_RENDER_OFFSET_Y);
}

export function adjustWokaUiY(baseY: number): number {
    return baseY + WOKA_UI_OFFSET_Y;
}
